import ReviewModal, {ProductProps, ImageOptions, ShowOptions} from './reviews/reviewModal';
import {SizeRatingSize} from './reviews/reviewModal/form/sizeRating';

interface ReviewsOptions {
    product: ProductProps;
    sizeRating: boolean;
    sizes: SizeRatingSize[];
    imageOptions: ImageOptions;
}

export default class ProductReviews {

    private _options: ReviewsOptions;
    private _initDeferred: JQuery.Deferred<void> = jQuery.Deferred();
    private _reviewModalRef = React.createRef<ReviewModal>();

    private _initReviewModal(): JQuery.Deferred<void> {
        let deferred = jQuery.Deferred();

        if (this._reviewModalRef.current) {
            return deferred.resolve();
        }

        ReactDOM.render(
            <ReviewModal
                ref={this._reviewModalRef}
                product={this._options.product}
                sizeRating={this._options.sizeRating}
                sizes={this._options.sizes}
                imageOptions={this._options.imageOptions}
            />,
            $j('<div/>').appendTo('body')[0],
            () => {
                deferred.resolve();
            }
        );

        return deferred;
    }

    showReviewModal(options: ShowOptions) {
        this._reviewModalRef.current.show(options);
    }

    init(options: ReviewsOptions): JQuery.Deferred<void> {
        if (!this._options) {
            this._options = options;

            this._initReviewModal().done(() => {
                this._initDeferred.resolve();
            });
        }

        return this._initDeferred;
    }

    onInit(handler: Function) {
        this._initDeferred.done(() => {
            handler();
        });
    }
}
